import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import camelCase from 'lodash/camelCase';

import './styles.scss';

/***
 * This component knows to add given components at the end of a children.
 * The components are added in a flex container.
 * Each component is displayed only if a mapped property (set by the parent) is `true`
 * for the specified item.
 * */
const ItemTitleWithIcons = (props) => {
  const { children, item, iconsMap } = props;
  const { type: childrenType } = children || {};
  const childrenProps = (children || {}).props || {};
  const [additionalIcons, setAdditionalIcons] = useState([]);
  const [childrenStyle, setChildrenStyle] = useState(null);

  useEffect(() => {
    let newAdditionalIcons = [];
    const itemKeys = Object.keys(iconsMap);

    itemKeys.forEach((itemKey) => {
      const iconComponent = iconsMap[itemKey];

      if (iconComponent) {
        const keyValue = item[itemKey] || item[camelCase(itemKey)];
        if (keyValue && iconComponent) {
          newAdditionalIcons.push(
            React.cloneElement(iconComponent, {
              ...iconComponent.props,
              key: newAdditionalIcons.length,
            }),
          );
        }
      }
    });

    setAdditionalIcons(newAdditionalIcons);

    const newChildrenStyle = getChildrenStyle(newAdditionalIcons.length);
    setChildrenStyle(newChildrenStyle);
  }, [item]);

  /*
   * Checks the type of the children.
   * If there is an element and not a text children
   * it computes the style for it.
   * */
  const getChildrenStyle = (newIconsLength) => {
    let className = null;
    let style = {};

    if (childrenType) {
      ({ className } = childrenProps);
      style = childrenProps.style || {};

      if (className && className.split(' ').includes('short')) {
        style.maxWidth = `${38 - newIconsLength * 3}ch`;
      }
    }

    return style;
  };

  return (
    <div className="ItemTitleWithIcons flex-vertical-align">
      {(childrenType &&
        React.cloneElement(children, {
          ...(childrenProps || {}),
          style: childrenStyle,
        })) ||
        children}
      {!!additionalIcons.length && (
        <div className="item-icons-container">{additionalIcons}</div>
      )}
    </div>
  );
};

ItemTitleWithIcons.propTypes = {
  /*
   * The item this component is used for.
   * */
  item: PropTypes.object.isRequired,
  /*
   * The list of mapped item properties and components
   * we need to display.
   * */
  iconsMap: PropTypes.object,
};

ItemTitleWithIcons.defaultProps = {
  item: {},
  iconsMap: {},
};

export default ItemTitleWithIcons;
